import { BASE_ADMIN_API_ROOT_PATH } from '../../shared/api/constants/path.constants';

const ADMIN_DELIVERY_ZONES_API_ROOT = `${BASE_ADMIN_API_ROOT_PATH}/delivery-zones`;

export const ADMIN_DELIVERY_ZONES_API_PATHS = {
  GET_DELIVERY_ZONES: `${ADMIN_DELIVERY_ZONES_API_ROOT}`,
  CREATE_DELIVERY_ZONE: `${ADMIN_DELIVERY_ZONES_API_ROOT}`,
  GET_DELIVERY_ZONE_BY_ID: (deliveryZoneId: string) => `${ADMIN_DELIVERY_ZONES_API_ROOT}/${deliveryZoneId}`,
  UPDATE_DELIVERY_ZONE: (deliveryZoneId: string) => `${ADMIN_DELIVERY_ZONES_API_ROOT}/${deliveryZoneId}`,
  ARCHIVE_DELIVERY_ZONE: (deliveryZoneId: string) => `${ADMIN_DELIVERY_ZONES_API_ROOT}/${deliveryZoneId}`,
  RESTORE_DELIVERY_ZONE: (deliveryZoneId: string) => `${ADMIN_DELIVERY_ZONES_API_ROOT}/${deliveryZoneId}/restore`,
};
